"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireDefault(require("../base/component"));

var _poptip = _interopRequireDefault(require("../poptip"));

var _index = _interopRequireDefault(require("../icon/index"));

var _DatePanel = _interopRequireDefault(require("../date-picker/DatePanel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DateRangePicker = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(DateRangePicker, _KZUIComponent);

  var _super = _createSuper(DateRangePicker);

  function DateRangePicker(props) {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "startModify", void 0);

    _defineProperty(_assertThisInitialized(_this), "endModify", void 0);

    _defineProperty(_assertThisInitialized(_this), "date_picker", void 0);

    _this.autoBind('handleSelect', 'handleClick', 'handleBlur');

    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return {
        expand: false,
        start: props.start,
        end: props.end,
        result: [[-1, -1], [-1, -1]],
        value: "".concat(props.start, " ~ ").concat(props.end),
        startModify: false,
        endModify: false,
        refresh: false
      };
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      this.setState({
        refresh: true
      }, function () {
        if (_this2.state.expand === true) {
          _this2.setState({
            start: _this2.props.start,
            end: _this2.props.end,
            result: [[-1, -1], [-1, -1]],
            value: "".concat(_this2.props.start, " ~ ").concat(_this2.props.end),
            startModify: false,
            endModify: false
          });
        }
      });
    }
    /*  to update the global data of daterangepicker
          @result[0] is the selected btns' index in panel1
          @result[1] is the selected btns' index in panel2
          @result[i][0] is the start btn's index in paneli
          @result[i][1] is the end btn's index in paneli
          @date is the input string type date
          @index is the btn's index
          @target indicates which panel is chosen
      */

  }, {
    key: "handleSelect",
    value: function handleSelect(date, index, target) {
      var _this$state = this.state,
          start = _this$state.start,
          end = _this$state.end,
          startModify = _this$state.startModify,
          endModify = _this$state.endModify,
          value = _this$state.value;
      var result = this.state.result;

      if (!startModify && !endModify) {
        if (target === 0) {
          start = date;
          result[target][0] = index;
          startModify = true;
        } else {
          end = date;
          result[target][1] = index;
          endModify = true;
        }
      } else if (!startModify) {
        start = date;
        result[target][0] = index;
        startModify = true;
      } else if (!endModify) {
        end = date;
        result[target][1] = index;
        endModify = true;
      }

      var startTime = new Date(start).getTime();
      var endTime = new Date(end).getTime();
      value = startTime > endTime ? "".concat(end, " ~ ").concat(start) : "".concat(start, " ~ ").concat(end);
      this.setState({
        end: end,
        start: start,
        expand: !this.startModify || !this.endModify,
        value: value,
        result: result,
        startModify: startModify,
        endModify: endModify
      });

      if (startModify && endModify) {
        var finalStart = start;
        var finalEnd = end;

        if (startTime > endTime) {
          var t = finalStart;
          finalStart = finalEnd;
          finalEnd = t;
        }

        this.props.onChange({
          start: finalStart,
          end: finalEnd
        });
      }
    }
  }, {
    key: "handlePanel",
    value: function handlePanel(year, month, pos) {
      var _this$state2 = this.state,
          start = _this$state2.start,
          end = _this$state2.end;
      var val = "".concat(year, "-").concat(month + 1, "-1");

      if (pos === 0) {
        this.setState({
          start: val,
          value: "".concat(val, " ~ ").concat(end),
          refresh: false
        });
      } else {
        this.setState({
          end: val,
          value: "".concat(start, " ~ ").concat(val),
          refresh: false
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (e.relatedTarget && this.date_picker.contains(e.relatedTarget)) {
        e.preventDefault();
        return;
      }

      this.setState(_objectSpread({}, this.state));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var clsPrefix = 'kui-date-picker';
      var _this$props = this.props,
          className = _this$props.className,
          error = _this$props.error,
          disabled = _this$props.disabled,
          style = _this$props.style,
          name = _this$props.name;
      var _this$state3 = this.state,
          result = _this$state3.result,
          value = _this$state3.value,
          start = _this$state3.start,
          end = _this$state3.end,
          refresh = _this$state3.refresh,
          expand = _this$state3.expand;
      var cls = (0, _classnames["default"])(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-error"), error), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _classNames), className);
      var index1 = result[0].filter(function (item) {
        return item !== -1;
      });
      var index2 = result[1].filter(function (item) {
        return item !== -1;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style,
        onBlur: this.handleBlur,
        ref: this.storeRef('date_picker')
      }, /*#__PURE__*/React.createElement(_poptip["default"], {
        isPopover: true,
        visible: expand,
        onVisibleChange: function onVisibleChange(visible) {
          return _this3.setState({
            expand: visible
          });
        },
        theme: "light",
        trigger: "click",
        className: "".concat(clsPrefix, "-date-range-panel"),
        placement: "bottom-left",
        tip: /*#__PURE__*/React.createElement("div", {
          className: cls
        }, /*#__PURE__*/React.createElement("header", {
          className: "".concat(clsPrefix, "-date-header")
        }, /*#__PURE__*/React.createElement("span", null, "\u5F00\u59CB\u65E5\u671F ~ \u7ED3\u675F\u65E5\u671F")), /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-date-panels")
        }, /*#__PURE__*/React.createElement(_DatePanel["default"], {
          value: start,
          valueAno: end,
          onChange: function onChange(date, index) {
            return _this3.handleSelect(date, index, 0);
          },
          onPanelChange: function onPanelChange(year, month) {
            return _this3.handlePanel(year, month, 0);
          },
          onCollapse: function onCollapse() {
            return _this3.handleClick();
          },
          index: index1,
          pos: 1,
          indexOther: index2,
          refresh: refresh
        }), /*#__PURE__*/React.createElement(_DatePanel["default"], {
          value: end,
          valueAno: start,
          onChange: function onChange(date, index) {
            return _this3.handleSelect(date, index, 1);
          },
          onPanelChange: function onPanelChange(year, month) {
            return _this3.handlePanel(year, month, 1);
          },
          onCollapse: function onCollapse() {
            return _this3.handleClick();
          },
          index: index2,
          pos: 2,
          indexOther: index1,
          refresh: refresh
        })))
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-date-display")
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        name: name,
        value: value,
        readOnly: true
      }), /*#__PURE__*/React.createElement(_index["default"], {
        type: "calendar"
      }))));
    }
  }]);

  return DateRangePicker;
}(_component["default"]); // DateRangePicker.defaultProps = {
//     name: '',
//     onChange: () => {},
//     start: '',
//     end: '',
// };
// DateRangePicker.propTypes = {
//     name: PropTypes.string,
//     onChange: PropTypes.func,
//     start: PropTypes.string,
//     end: PropTypes.string,
// };


var _default = DateRangePicker;
exports["default"] = _default;